export default {
  common: {
    searchPlac: "Search for questions, topics or people",
    bottomTitle: "Penfoam Cloud AI Tools",
    tip: "hint",
    sure: "Sure",
    cancel: "Cancel",
    language: "language",
    onlineService: "onlineService",
    del: "Delete",
    edit: "Edit",
  },
  nav: {
    title: "Spray Room AI",
    noNoTice: "No unread notifications",
    lookAll: "View All",
    login: "Log in",
    register: "register",
    set: "set up",
    logout: "quit",
    remainingPoints: "Remaining points",
    remainingArticles: "Remaining articles",
    recharge: "top up",
    index: "front page",
    mustRead: "Webmasters must read",
    billingMethod: "Billing method",
    adminConsole: "Management Console",
    notice: "notify"
  },
  sidebar: {
    title: "Spray Room Management Console",
    adminConsole: "Account Management",
    recharge: "top up",
    webmanage: "Site Management",
    push: "Interface file related",
    webkeywords: "Fields and Keywords",
    aisetting: "Generate Release Settings",
    test: "Running tests manually",
    data: "Article Storage",
    userWallet: "Referral Rebate"
  },
  index: {
    topTitle: "utomatically generate content through keywords and publish automatically",
    topSubTitle1:
      "Based on the ChatGpt large language model developed by OpenAI, relevant articles are generated by keywords without writing generation rules. Currently supports GPT3.5 and GPT4.0",
    topSubTitle2:
      "Automatically generate highly matching original content, match the most appropriate SEO optimization strategy through our built-in algorithm, and intelligently output high-quality SEO content in a timely and quantitative manner, making SEO more effective!",
    topSubBtn: "More features explained",
    topSubBtnTilte: "Penfo Cloud AI Tool - Functional Details",
    apiKeyPlace: "Please enter the API Key for ChatGpt3.5",
    articleKey: "Article Keywords",
    articleKeyPlace: "Please enter the keywords for the article you want to generate",
    btn: "Generate article immediately",
    label1: "title",
    label2: "Keywords",
    label3: "TAG",
    label4: "Introduction",
    label5: "text",
    title1: "Rich optional SEO optimization options",
    title11:
      "The system has built-in mainstream SEO optimization methods in the industry, including combined titles, text length filtering, intelligent tag extraction, automatic bolding of keywords, keyword insertion, automatic internal links, automatic image matching, active push, etc.",
    title1Tag1: "AI Title",
    title1Tag2: "AI Content",
    title1Tag3: "Custom Style",
    title1Tag4: "Smart Tags",
    title1Tag5: "Bold keywords",
    title1Tag6: "Insert keywords",
    title1Tag7: "Automatic internal linking",
    title1Tag8: "Automatic picture matching",
    title1Tag9: "Active push",
    title2: "Highly intelligent AI system",
    title21:
      "Using the most powerful OPENAI language model on the market, it can use AI to imitate titles based on the keyword information provided by users and the existing content on the Internet, and generate articles based on the titles. The content is highly original, logically clear, and accurate. Users can customize the editing and generation rules to make the articles more in line with the content requirements of the website, and the effect exceeds that of most manual editing.",
    title22: "So we are not just a generator, but also a powerful intelligent web editor.",
    title2Tag1: "Deep Learning",
    title2Tag2: "Language Model",
    title2Tag3: "AI Models",
    title2Tag4: "Highly readable",
    title2Tag5: "Clear logic",
    title3: "Stable and reliable automatic running of generated tasks",
    title31:
      "The generation task is automatically run by the server at a fixed time and quantity every day, without supervision. After the article is successfully generated, it will be automatically pushed to the backend of your website.",
    title32:
      "You only need to set the necessary parameters to achieve fully managed, unattended automatic updates of high-quality articles.",
    title33: "Please register to experience more features.",
    title3Tag1: "Automatically generate",
    title3Tag2: "No need to hang up",
    title3Tag3: "Unattended",
    title3Tag4: "Automatic publishing",
    title4: "Supported content management systems, website building programs/platforms",
    title5: "Latest Industry News"
  },
  mustRead: {
    all: "all",
    keepRead: "Continue reading",
    publishedIn: "Published on",
    searchPlac: "Search for questions, topics or people",
    hotArticles: "Popular Articles",
    generatorRelated: "Generator related"
  },
  billingMethod: {
    rule: "Generate points consumption rules",
    rule1: "Contact customer service to get 100 points + 10 push quotas for testing.",
    rule2: "Billing is divided into: token consumption points billing and article push billing.",
    rule3:
      "Points consumption rules: Using your own API key will not charge points. If you do not have an API key, using our official API key will deduct points corresponding to the token consumed.",
    rule41: "Token consumption points billing: deduct the corresponding points according to the tokens consumed in generating articles.",
    rule42: "The ratio of GPT3.5 points to tokens is 100:50000.",
    rule43: "The ratio of GPT4.0 points to tokens is 100:1000.",
    rule44: "According to an article of about 500 words, it will cost about 1000-1300 tokens, and the points will be deducted as follows:",
    rule45: "GPT3.5 corresponds to a deduction of 2-2.6 points.",
    rule46: "GPT4.0 corresponds to a deduction of 100-130 points.",
    rule5:
      "Using GPT4.0 will deduct an additional 40 points per article because you need to pay for the number of interface calls.",
    rule6:
      "When adding custom prefix and suffix prompts, token consumption will increase. The more restrictions there are, the more tokens will be consumed.",
    rule7:
      "Pushed articles: No article will be deducted if it is not published to the website. Manually running the test consumes one pushed article.",
    rule8: "Recharge ratio: 1 yuan = 100 points.",
    rule9:
      "OpenAI's billing rules are complicated, and there may be deviations in the conversion of points using this platform. It is recommended to apply for the GPT3.5 or 4.0 API key yourself, which is more cost-effective!"
  },
  adminConsole: {
    welcome: "Welcome",
    changePassword: "Change Password",
    remainingArticles: "Remaining articles",
    rechargeArticles: "Recharge number",
    remainingPoints: "Remaining points",
    rechargePoints: "Recharge Points",
    details: "Points income and expenditure details",
    time: "time",
    consumePoints: "Consume points",
    consumeArticles: "Consumption of articles",
    type: "type",
    info: "Related information",
    more: "More",
    noMore: "No more content",
    website: "website",
    jump: "Jump",
  },
  reset: {
    title: "Change Password",
    set: "User Settings",
    old: "Current Password",
    new: "New password",
    sure: "Confirm Password",
    submit: "Submit Submit",
    suc: "Password changed successfully"
  },
  accountsetting: {
    title: "Basic Information",
    account: "account",
    realName: "Real name",
    contact: "Contact Details",
    mobile: "phone number",
    email: "Common mailbox",
    submit: "submit",
    suc: "Modify information successfully"
  },
  verify: {
    title: "Apply for certification",
    currentState: "Current Status",
    notCertified: "Unauthenticated",
    authenticationType: "Certification Type",
    personalAuthentication: "Personal certification",
    institutionalAccreditation: "Institutional Accreditation",
    realName: "Real name",
    identityCard: "ID number",
    contact: "Contact Details",
    authDesc: "Certification Description",
    accessories: "appendix",
    clickUp: "Click Upload",
    upTip: "Please submit a scan of your ID card or organization code",
    submit: "submit",
    suc: "Modify information successfully"
  },
  login: {
    title: "Login with username and password",
    loginKey: "Email / Username",
    passwd: "password",
    btn: "Log in",
    rememberMe: "Remember Me",
    retrievePassword: "Recover your password"
  },
  addfunds: {
    title1: "Select the recharge amount (only for users who don’t have API Key, those who have their own don’t need to purchase)",
    integral: "integral",
    btn: "Alipay Payment",
    title2: "Select a hosting plan (need to purchase regardless of whether you have an API Key)",
    article: "Articles",
    rmb: "Yuan"
  },
  webmanage: {
    title: "Site Management",
    addWeb: "Add a website",
    batchAdd: "Batch Add",
    webSearch: "Site Search",
    orderNumber: "Serial number",
    web: "website",
    record: "Record",
    consumeToken: "Consume Token",
    consumePoints: "Consume points",
    bindingAPI: "Binding API",
    operate: "operate",
    openWeb: "Click here to open the homepage",
    lookRecord: "Click here to view the generated records",
    lookFinsh: "Click here to view the completion status",
    pleaseBindAPI: "Please bind API",
    apiDown: "Interface Download",
    columnSettings: "Column settings",
    content: "Content Settings",
    manualTest: "Manual Testing",
    articleMana: "Article Management",
    deletWeb: "Delete a website",
    selectDel: "Remove check",
    bindApiKey: "Bind API key",
    official: "official",
    self: "Own",
    tipText: "Free version may limit the calling frequency",
    bindPlace: "Please enter the API key to be bound",
    delTip: "This operation will permanently delete the site, do you want to continue?",
    hadDel: "Undeleted",
    delSuc: "Deleted successfully",
    selectContent: "Please select content",
    unbound: 'Unbound',
  },
  addsite: {
    title: "Add a website",
    tip11: "Please enter your website domain name.",
    tip12: ", please select",
    tip13: "Protocol header, otherwise please select",
    tip14: "Protocol header.",
    eg: "like",
    tip21: "Please upload your verification documents to",
    tip22: "Website root directory",
    tip23: ", and confirm that it can be accessed normally. It can be deleted after verification.",
    downFile: "Download verification file",
    startVerify: "Start verification",
    submit: "submit",
    inputWeb: "Please enter the domain name",
    verifySuc: "Verification Success",
    addSuc: "Added successfully",
    verifyTip1: "Please verify domain ownership",
    verifyTip2: "No verification required, just add"
  },
  addsiteMore: {
    title: "Adding websites in batches",
    description: "Format description",
    description1: "Official/key",
    description2:
      "|(Column Name 1; Column ID; Mode; Keyword 1, Keyword 2, Keyword 3; Start/Stop)(Column Name 2; Column ID 2; Mode; Keyword 1, Keyword 2, Keyword 3; Start/Stop)(Column Name 3; Column ID 3; Mode; Keyword 1, Keyword 2, Keyword 3; Start/Stop)",
    divided: "Divided into",
    divided1: "domain name",
    divided2: "GPT Version",
    divided3: "Official or self-owned, self-owned requires API KEY",
    divided4:
      "Bind column keywords and generation mode: fill in the column name at will; corresponding column ID; AI mode = 1, custom mode = 2, keywords (separated by English commas, multiple keywords can be filled in)",
    eg: "Example",
    eg1: "(News column; 10; 1; current affairs news, sports news; start)",
    eg2: "(Technology column; 15; 1; Chips, aerospace materials; Stop)",
    eg3: "((Military news; 13; 2; South China Sea situation, Russia-Ukraine conflict; start)",
    official: "official",
    submit: "submit",
    verifyWeb: "Verify website",
    notVerifyWeb: "No verified website",
    verifyTip1: "Please upload your verification documents to",
    verifyTip2: "Website root directory",
    verifyTip3: ", and confirm that it can be accessed normally. It can be deleted after verification.",
    verifyTip4: "(Green means verification passed)",
    downloadFile: "Download verification file",
    validateWebsite: "Start verification",
    addWebiste: "Add approved website",
    verifySuc: "Verification Success",
    addSuc: "Added successfully"
  },
  push: {
    title: "Get the push interface file",
    applicationDescription: "Usage",
    applicationDescription1: "Used to publish the article to your website after it is generated.",
    applicationDescription2: "Please download",
    applicationDescription3: "Publishing Interface",
    applicationDescription4: "File, upload to your website",
    applicationDescription5: "root directory",
    applicationDescription6: "Automatic publishing may be used by some",
    applicationDescription7: "Firewall",
    applicationDescription8:
      "Rule interception. If your server has a firewall enabled, it is recommended to add a URL whitelist.",
    applicationDescription9: "How to add URL whitelist to Baota Panel Firewall?",
    selectApi: "Please select the interface you need",
    userName: "username",
    password: "password",
    description: "illustrate",
    description1: "Please fill in your",
    description2: "ABC Backstage",
    description3: "Account Password",
    subAdminLogin: "Sub-administrator login",
    save: "save",
    apiDown: "Release interface download",
    apiTest: "Release interface test",
    selectApi: "Please select the interface",
    selectWeb: "Select a website",
    apiSuc: "Release interface test successful",
    saveSuc: "Saved successfully"
  },
  webkeywords: {
    title: "Columns and keywords",
    addColumn: "Add column",
    batchAddColumns: "Add columns in batches",
    columnName: "Column Name",
    limitTen: "Up to 10 characters",
    columnId: "Column ID",
    pushColumn: "Target column/category ID to be published",
    subColumnId: "Sub-section ID",
    enterSubColumnId: "Please enter the sub-section ID",
    subColumnThree: "Sub-section 3",
    puhsTo: "Push to",
    article: "article",
    product: "product",
    cancel: "Cancel",
    save: "save",
    aiMode: "AI Mode",
    diyMode: "Custom Mode",
    keyWord: "Keywords",
    enterKeyWord: "Please enter your keywords and click to preview the results.",
    preview: "Preview",
    previewTitle: "Preview Title",
    wait: "It may take 30-60 seconds to preview the title, please wait",
    diyAdd: "Custom module (add column)",
    mode: "model",
    hadCreatArticles: "Number of articles generated",
    operate: "operate",
    state: "state",
    keyWordBind: "Keyword Binding",
    delColumn: "Delete column",
    enabled: "Enabled",
    notEnabled: "Not enabled",
    enterTitle: "Please enter a title",
    batchEnabled: "Batch activation",
    batchNotEnabled: "Bulk Deactivation",
    batchDel: "Batch Deletion",
    commonProblem: "Frequently asked questions",
    problem1: "How do I fill in the column name and column ID? What are the effects?",
    problem11:
      "The column name is only for the convenience of users to distinguish different columns. It is only used for display and has no effect on the generation behavior.",
    problem12:
      "The column ID is used to post the article to the corresponding column when publishing, so users who need to publish through the interface file must fill in the column ID correctly.",
    problem13:
      "Both column names and column IDs can be added repeatedly, which can be used to use multiple keyword types in the same column.",
    problem2: "How to view the WordPress column ID?",
    problem21: "In the WordPress backend, find the category menu under the article module and open it.",
    problem22: "Point the mouse to the category name and check the link displayed in the lower left corner of the browser to find",
    problem23: ", the number displayed is the ID of this column.",
    problem3: "Why do some columns generate very few articles? What happens if no articles are generated for a long time?",
    problem31:
      "Different keywords generate new content on the Internet at different speeds. Due to the long-term generation of the same keywords, especially when there are few keywords, unpopular industries, designated target websites, and harsh filtering conditions, the generation efficiency will gradually decrease.",
    problem32: "It is recommended to bind as many keywords as possible, which will have a significant effect on improving generation efficiency.",
    problem4: "How to generate content for a specified website and keywords?",
    problem41: "When creating a column, select custom mode and bind keywords.",
    problem42: "Complete the generation and release settings of the website",
    problem5: "What is AI mode? What is custom mode?",
    problem51:
      "AI mode: suitable for industries with fewer main keywords, it can generate a large number of articles by expanding related long-tail words through a small number of keywords",
    problem52:
      "Custom mode: The input keyword is the title of the article. Directly call the input keyword to request the article content",
    diyBind: "Custom modules (keyword binding)",
    addColumnSuc: "Added column successfully",
    editColumnSuc: "Edit column successfully",
    enabledTip: "This operation will permanently disable this column, do you want to continue?",
    noEnabledTip: "This operation will permanently enable this column, do you want to continue?",
    delTip: "This operation will permanently delete the column, do you want to continue?",
    hadCancelEnabled: "Deactivation canceled",
    hadCancelNotEnabled: "Deactivated",
    hadCancelDel: "Undeleted",
    enabledSuc: "Enabled successfully",
    notEnabledSuc: "Stop Success",
    enterSaveKeyWord: "Please enter the keywords you want to save",
    saveSuc: "Saved successfully",
    enterKeyWord: "Please enter keywords",
    selectContetn: "Please select content"
  },
  massaddtype: {
    title: "Add columns in batches",
    description1:
      "Format description: Column name | Column ID | Mode (1: AI, 2: Custom) | Keyword 1, Keyword 2, Keyword 3....., such as:",
    description2: "Stock capital allocation | 10 | 1 | Which stock capital allocation company is the best? Find XXX for stock capital allocation, professional stock capital allocation agency",
    description3:
      ", one per line. After adding columns in batches, please remember to set keywords, otherwise you will not be able to obtain the content.",
    submit: "submit",
    addSuc: "Successfully added a large number of fields"
  },
  test: {
    title: "Running tests manually",
    btn: "start",
    tip11: "Please select the domain name to be tested, click",
    tip12: "button to start the test. It takes about 30-60 seconds, please be patient",
    tip2: "Manual build in progress",
    tip31: "By binding keywords",
    tip32: "Bind column ID",
    tip33: "Get the title",
    tip34: "Generate keywords",
    tip35: "Generate TAG tag",
    tip36: "Description",
    tip37: "Content",
    tip38: "Release Status",
    tip39: "Click to view",
    tip41: "Note: This page was generated for",
    tip42: "test",
    tip43: "The design has",
    tip44: "Speed ​​Limit",
    tip45: ", if you need to generate quickly, please turn on",
    tip46: "Automatic operation in the cloud",
    problem: "Frequently asked questions",
    problem1: "What settings are required before running a build task?",
    problem11: "Verify website ownership and add the website to the platform.",
    problem12:
      "Set up the columns of the corresponding website, fill in the correct column ID, and add keywords to each column, preferably multiple ones.",
    problem13: "Complete the settings on the Generate Release Settings page and click the Save button.",
    proble2: "How long does it take to generate the article?",
    proble21: "Each website needs to wait for the first time to run the generation task.",
    proble22: "1-2 minutes",
    proble23: "You don't have to wait to generate the article, and subsequent tasks will run faster.",
    proble24:
      "Different keywords have different levels of content richness. Adding as many keywords as possible can improve generation efficiency.",
    proble3: "After generating the article, how to publish the article content to the website?",
    proble31:
      "If you want to automatically publish to the website, please upload the interface file of the corresponding program and set the article delivery method to",
    proble32: "Publish to my website backend through the interface file",
    proble33: "If you need to manually retrieve articles, or edit before publishing, please set the article delivery method to",
    proble34: "Put the article into the article temporary storage library",
    proble4: "How to enable generation tasks?",
    proble41: "Columns and keywords",
    proble42: "Page, you need to set the column status to enabled before it can be automatically generated",
    proble43: "Generate Release Settings",
    proble44: "The page has an automatic run generation switch. Once it is turned on, the server will automatically run the generation task.",
    pushSuc: "Published successfully",
    pushErr: "Publishing failed",
    pointsConsumption: "Points consumption",
    aiModel: "Model used",
  },
  data: {
    title: "Article Storage",
    allStatus: "All Status",
    toEdit: "To be edited",
    hadEdit: "Edited",
    hadPush: "Edited",
    search: "Query",
    page: "page",
    all: "all",
    head: "title",
    status: "state",
    time: "time",
    consumeToken: "Consume Token",
    consumePoints: "Consume points",
    operate: "operate",
    del: "delete",
    push: "release",
    selectDel: "Please select the record to delete",
    delTip: "This operation will permanently delete the article, do you want to continue?",
    delSuc: "Deleted successfully",
    hadDel: "Undeleted",
    selectPush: "Please select the record to publish",
    pushTip: "This operation will publish the article, do you want to continue?",
    pushSuc: "Published successfully",
    pushErr: "Unpublished",
    AIModelVersion: "AI model version",
  },
  aisetting: {
    title: "Generate Release Settings",
    importTemplate: "Import from template",
    saveTemplate: "Save as Template",
    autorun: "Automatic operation in the cloud",
    autorunTip1: "Automatically run tasks in the cloud.",
    autorunTip2: "As long as there are points in your account, the system will automatically run according to the time you set, even if you",
    autorunTip3: "Shutting down the computer does not affect",
    runTime: "Run time",
    runTimeTip1: "24 hours operation (default)",
    runTimeTip2: "Run at a specified time",
    runTimeTip3: "Please select the time period you want to run",
    clock: "o'clock",
    getArticle: "Number of articles retrieved per hour",
    getArticleTip1: "Full site release",
    getArticleTip2: "Articles/hour, the number of articles in each column is random.",
    getArticleTip3: "This is only a maximum amount and is not guaranteed to be achieved.",
    getArticleTip4: ", usually up to 1,000 articles per hour (per station),",
    contentSyle: "Custom content style",
    contentSyleTip1: "Default Mode",
    contentSyleTip2: "Professional Mode",
    contentSyleTip3: "Custom Mode",
    contentSyleTip4: "Default mode: The system will request content based on keywords.",
    contentSyleTip5: "Example: Generate an article with 'XXXXX' as the keyword",
    contentSyleTip6:
      "Professional mode: This site has collected content generation methods from various fields on the Internet. Please select fields related to the content of your website to make the content more accurate.",
    contentSyleTip7: "Prefix",
    contentSyleTip8: "suffix",
    contentSyleTip9: "Custom mode: You can customize the prefix and suffix of the question to request content",
    contentSyleTip10: "Example",
    contentSyleTip11: "You are a professional doctor now, you need to help me write from a doctor's perspective,",
    contentSyleTip12: "Generate an article with 'XXXX' as the keyword",
    contentSyleTip13: ", the content needs to be related to cancer treatment.",
    contentSyleTip14: "Red is the prefix and blue is the suffix.",
    textLength: "Text length selection",
    textLengthTip1:
      "Please select the required text length (not necessarily achievable, ultimately depends on the AI's creative capabilities.)",
    textLengthTip2: "Word left and right",
    keyWordLimit: "Limitations of articles generated by single keyword",
    keyWordLimitTip1: "Each keyword can generate a maximum of",
    keyWordLimitTip2: "Articles.",
    keyWordLimitTip3: " If left blank or set to 0, there is no limit on the number of articles. (Just leave it blank for custom mode)",
    author: "Default Author",
    authorTip1: "Always use the author directly, never generate one from the web page",
    article: "Default article source",
    relevance: "Relevance Optimization",
    relevanceTip1: "Automatically insert the current keyword at a random position in the text",
    relevanceTip2: "Second-rate.",
    relevanceTip3: "When the current keyword appears in the text, it will be automatically bolded.",
    relevanceTip4: "Insert the article title at the beginning of the text.",
    relevanceTip5: "Use html tags:",
    relevanceTip6: ", not including",
    relevanceTip7: ",For example:",
    relevanceTip8: ", leave it blank to use no label.",
    tags: "Tags",
    tagsTip1: "Smart extraction label, quantity",
    tagsTip2: "indivual",
    tagsTip3: "Currently generating keywords as tags",
    tagsTip4: "Don’t use tags",
    fixedLink: "Permalink",
    fixedLinkTip1: "In the text",
    fixedLinkTip2: "Existing",
    fixedLinkTip3: "Add links to vocabulary, one per line, up to 200, format:",
    fixedLinkTip4: "Article Generation",
    fixedLinkTip5: "If the text appears",
    fixedLinkTip6: "Article Generation",
    fixedLinkTip7: "This word, then link it to",
    fixedLinkTip8: "If a word appears multiple times in the text, only link the first time it appears.",
    fixedLinkTip9: "Links can be internal or external, can be homepage or internal pages, but should not include",
    fixedLinkTip10: "symbol.",
    fixedLinkTip11: "Permalinks, one per line",
    keywordDensity: "Keyword density",
    keywordDensityTip1: "Randomly select from the following keywords",
    keywordDensityTip2: "Insert into a random position in the text, or turn it off if it is 0. It can be a single word such as",
    keywordDensityTip3: "Article Generation",
    keywordDensityTip4: ", or it can be a piece of html, such as",
    keywordDensityTip5: "Article Generation",
    keywordDensityTip6: "，每行一个，最多1万个。",
    keywordDensityTip7: "Keywords to be inserted, one per line",
    autoImg: "Automatic picture matching",
    autoImgTip1: "Each article has a picture",
    autoImgTip2: "Frames (up to 5 frames)",
    autoImgTip3:
      "Please fill in the image URL below. The system will randomly select images from it instead of getting them from the Internet. One per line, up to 2000.",
    autoImgTip4: "Customize the image URL, one per line, such as:",
    autoImgTip5:
      "If the image cannot be displayed normally, it may be because the network image has anti-hotlink settings. Please try using",
    autoImgTip6: "Image localization",
    autoImgTip7: "or",
    autoImgTip8: "Upload to cloud storage",
    autoImgTip9: "solve.",
    imgAlt: "Image alt attribute",
    imgAltTip1: "Use relevant long-tail words",
    imgAltTip2: "Use current keyword (default)",
    imgAltTip3: "Use article title",
    imgAltTip4: "Blank alt attribute",
    addStart: "Add content at the beginning of the article",
    addStartTip1: "exist",
    addStartTip2: "Beginning of the article",
    addStartTip3: "Add a paragraph to allow the use of",
    addStartTip4: "Label, no more than 500 characters.",
    addStartTip5: "Add content at the beginning of the article",
    addEnd: "Add content at the end of the article",
    addEndTip1: "exist",
    addEndTip2: "End of article",
    addEndTip3: "Append a paragraph to allow the use of",
    addEndTip4: "Label, no more than 500 characters.",
    addEndTip5: "Add content at the end of the article",
    payType: "Article delivery method",
    payTypeTip1: "Automatic release: By",
    payTypeTip2: "Interface File",
    payTypeTip3: "Publish to the website backend, save to",
    payTypeTip4: "Article Storage",
    payTypeTip5: "Please obtain the interface file for publishing by yourself.",
    payTypeTip6: "Manual publishing: directly put the article into",
    payTypeTip7: "Article Storage",
    payTypeTip8: ", so that you can manually edit and publish or copy to other media, or download in batches to your local computer.",
    pushTime: "Article release time",
    pushTimeTip1: "Publish immediately after generation is completed",
    pushTimeTip2: "Random release time during this period",
    pushTimeTip3: "(Only available when auto-publish is turned on)",
    pushTimeTip4: "Please select the time period you want to run:",
    baiduPush: "Baidu proactively pushes",
    baiduPushTip1: "Please fill in the Baidu resource platform push interface key:",
    baiduPushTip2: "Leave blank to disable.",
    baiduPushTip3:
      "Please also set the article publishing status to open for browsing, otherwise Baidu spider may not be able to crawl it.",
    byPush: "Bing proactive push",
    byPushTip1: "Please fill in the Bing Resource Platform push interface key:",
    byPushTip2: "Leave blank to disable.",
    byPushTip3: "Please also set the article publishing status to open for browsing, otherwise the Bing spider may not be able to crawl it.",
    pushErr: "Publishing failure notification",
    pushErrTip1: "When the article fails to be published, send me a site notification.",
    pseudoOriginal: "Title pseudo-original source",
    pseudoOriginalTip1: "Baidu",
    saveSet: "Save settings",
    templateName: "Template Name",
    operate: "operate",
    import: "Import",
    del: "delete",
    close: "closure",
    enterTemplateName: "Please enter a name for the template",
    saveSuc: "Saved successfully",
    saveTemplateSuc: "Template saved successfully",
    importSuc: "Import Success",
    delTip: "This operation will permanently delete the template, do you want to continue?",
    hadCancelDel: "Undeleted",
    delSuc: "Deleted successfully",
    imgMust: "Image is required",
    titleSource: "Title Source",
    titleSourceTip1: "Baidu",
    titleSourceTip2: "Google",
    lang: "Generate article language",
    langTip1: "Chinese",
    langTip2: "Traditional",
    langTip3: "English",
    googleSpiderPool: "Google Spider Pool",
    googleSpiderPoolTip1: "yes",
    googleSpiderPoolTip2: "no",
    googleSpiderPoolTip3: "Improved inclusion",
    filterTitleType: "Collected title filtering",
    filterTitleTypeTip1: "Filter Plain English",
    filterTitleTypeTip2: "Filter with Chinese",
    filterTitleTypeTip3: "No Filter",
    filterTitleTypeTip4: "Column only",
    filterTitleTypeTip5: "Bind AI mode in the title",
    titleInsertKeyword: "Insert keywords into title",
    titleInsertKeywordTip1: "Insert at the beginning",
    titleInsertKeywordTip2: "Insert end",
    titleInsertKeywordTip3: "Not inserted",
    bindAi: "Bind AI version",
    deductPoints: "Preview of points deduction this time",
    pushWeb: "Bound program name",
    delimiter: "Delimiter",
  },
  article: {
    pushTime: "Release time",
    comment: "Comments",
    reply: "To reply to an article please first",
    verify: "Real-name authentication",
    promoter: "sponsor",
    house: "Spray House",
    enterpriseCertification: "Enterprise Certification",
    ai: "AI generation in the cloud is easier",
    popularArticles: "Popular Articles",
    generatorRelated: "Generator related"
  },
  articleedit: {
    title: "Article Title",
    columnID: "Column ID",
    articleContent: "Article Content",
    wysiwyg: "WYSIWYG editor",
    toolbar: "Toolbar",
    code: "source code",
    bold: "Bold",
    incline: "tilt",
    numberedList: "Numbered List",
    itemList: "Project List",
    blockReference: "Blockquote",
    editHyperlink: "Edit Hyperlink",
    insertVideo: "Insert Video",
    fullScreen: "full screen",
    press: "according to",
    help: "Get Help",
    save: "save",
    savePush: "Save and Publish",
    enterConter: "Please enter the content of the article",
    savePushSuc: "Save and publish successfully",
    saveSuc: "Saved successfully",
    website: "Website",
    bindAi: "Bind AI version",
    useProgram: "Programs used",
  },
  forgotPassword: {
    title: "Recover your password",
    email: "Mail",
    next: "Next step",
    sucTip1: "Email Sent",
    sucTip2: "The password reset link has been sent to your email",
    sucTip3: "Please log in to your email and click the password reset link to change your password.",
    sucTip4: "If you can't find the email, please check spam, junk mail, etc."
  },
  forgotPasswordTwo: {
    title: "Recover your password",
    newPassword: "New Password",
    surePassword: "Confirm Password",
    sure: "Confirm Save",
    suc: "Password retrieval successful"
  },
  notice: {
    title: "notify",
    more: "More",
  },
  signup: {
    title: "Account and password registration",
    account: "username",
    passwd: "password",
    confirmPasswd: "Repeat password",
    mobile: "Phone number",
    email: "Email Address",
    btn: "register",
    suc: "Successful registration",
  },
  userWallet: {
    balance: "Balance",
    withdrawal: "Withdrawal",
    copy: "copy",
    withdrawalUrl: "Suggested Links",
    referralEarning: "Referral income",
    time: "time",
    withdrawalAmount: "Withdrawal amount",
    withdrawalTime: "Withdrawal time",
    enterAmount: "Please enter the withdrawal amount",
    withdrawalList: "Withdrawal List",
    conpySuc: "Copy Success",
    reference: "Recommended by",
    name: "Name",
    account: "account",
    recommendRate: "Commission Rate",
  }
};



// WEBPACK FOOTER //
// ./src/lang/en_US.js